module.exports = __webpack_public_path__ + "index-2.html";